
import { Component, Vue } from "vue-property-decorator"

@Component
export default class ExpandableSidebar extends Vue {
	private expanded: boolean = true;

	private toggleExpand (): void {
		this.expanded = !this.expanded
	}
}

